export default __webpack_public_path__ + "static/media/ic_language24.ce951c62.svg";